export default [
  {
    name: 'Type',
    prop: 'type',
    type: 'select',
    options: [
      {
        name: 'General',
        value: 'General'
      },
      {
        name: 'FSP',
        value: 'FSP'
      },
      {
        name: 'Campus Workshop',
        value: 'Campus Workshop'
      }
    ]
  },
  {
    name: 'Note',
    prop: 'text',
    type: 'wysiwyg'
  }
]
